export default __webpack_public_path__ + "static/media/thumbnail.eda161aa.png";